import { PublicClientApplication } from "@azure/msal-browser";

const msalConfig = {
    auth: {
        clientId: "50653594-45f1-4b6d-98b3-bb8325f2bf03",
        clientSecret: "uiR8Q~bT6vtlzo85FZ2qCoGa4tjF8fP1PZ5xTb9U",
        authority: "https://login.microsoftonline.com/77606d36-bb70-45aa-913b-a7da7dbcd2bb",
        redirectUri: "http://localhost:3000",
    },
};

const msalInstance = new PublicClientApplication(msalConfig);

// Request an access token
const tokenRequest = {
    scopes: ["api://50653594-45f1-4b6d-98b3-bb8325f2bf03/Files.ReadWrite.All"], // Replace "scopeName" with your actual scope
};

const getAccessToken = async () => {
    try {
        const account = msalInstance.getAllAccounts()[0];
        if (!account) {
            // You can replace this with msalInstance.loginRedirect if you want a redirect instead of a popup
            await msalInstance.loginPopup();
        }
        const response = await msalInstance.acquireTokenSilent({
            ...tokenRequest,
            account: msalInstance.getAllAccounts()[0]
        });
        console.log("Exported function called, token acquired successfully");
        return response.accessToken;
    } catch (error) {
        if (error.name === "InteractionRequiredAuthError") {
            // fallback to interaction when silent call fails
            return msalInstance.acquireTokenRedirect(tokenRequest)
        } else {
            console.log("Exported function called, error: ", JSON.stringify(error));
            throw error;
        }
    }
};

export default getAccessToken;